module.exports = __webpack_public_path__ + "static/media/tableau.1e81d053.jpeg";